import React from 'react';
import PropTypes from 'prop-types';
import { Button, ModalHeader, Modal, ModalFooter } from 'reactstrap';
const DisableModal = ({
  showModal,
  onHide,
  onAction
}) => /*#__PURE__*/React.createElement(Modal, {
  isOpen: showModal,
  className: "t-pm-modal"
}, /*#__PURE__*/React.createElement(ModalHeader, null, "Are you sure you want to disable multi-factor authentication?  This will erase your currently saved MFA secret."), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
  className: "t-pm-cancel",
  onClick: onHide
}, "Cancel"), /*#__PURE__*/React.createElement(Button, {
  className: "t-pm-action",
  onClick: onAction
}, "Disable Multi-Factor Authentication")));
DisableModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired
};
export default DisableModal;